import { useState } from 'react';
import Modal from '../../components/common/modal';
import { Tag } from '../../hooks/useTags';

interface TagPillProps {
  tag: Tag;
  checked: boolean;
  setCheckedTags: React.Dispatch<React.SetStateAction<number[]>>;
}

const TagPill: React.FC<TagPillProps> = ({ tag, checked, setCheckedTags }) => {
  const handleClick = (id: number, isSelecting: boolean) => {
    if (isSelecting) {
      setCheckedTags((prev) => [...prev, id]);
    } else {
      setCheckedTags((prev) => prev.filter((x) => x !== id));
    }
  };
  return (
    <button
      key={tag.id}
      className={` ${
        checked ? 'bg-blue-primary text-white' : 'bg-gray-background-light'
      } ml-2 mt-2 rounded-md text-sm font-bold`}
      onClick={() => {
        handleClick(tag.id, !checked);
      }}
    >
      <div className="flex px-3 py-2">
        <div className="grow pr-2">{tag.name}</div>
      </div>
    </button>
  );
};

interface ResourceTagModalProps {
  tags: Tag[];
  selectedTagIds?: number[];
  onChange: (selectedTagIds: number[]) => void;
  onExit: () => void;
}

export const ResourceTagsEditModal: React.FC<ResourceTagModalProps> = ({ onChange, onExit, tags, selectedTagIds }) => {
  const [checkedTagIds, setCheckedTagIds] = useState<number[]>(selectedTagIds || []);

  return (
    <>
      <Modal
        isModel={true}
        InnerComponent={
          <div
            onClick={(event) => {
              event.stopPropagation();
            }}
            className="inline-block transform overflow-hidden bg-white py-16 align-bottom shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-3xl sm:align-middle"
          >
            <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
              <div className="flex justify-start">
                <h3 className="blue-primary py-1 text-2xl font-normal">Add Resource Tags</h3>
              </div>
            </div>
            {tags.map((tag, _) => (
              <TagPill
                key={tag.id}
                tag={tag}
                checked={!!checkedTagIds?.includes(tag.id)}
                setCheckedTags={setCheckedTagIds}
              />
            ))}
            <div className="flex items-center justify-end gap-2 px-4 py-3">
              <button
                type="button"
                className="bg-blue-primary ml-4 h-8 w-16 rounded-sm px-2 text-center text-sm text-white"
                onClick={() => onChange(checkedTagIds)}
              >
                Save
              </button>
              <button
                type="button"
                className="inline-flex h-8 w-16 items-center rounded-sm border bg-white px-2 text-center text-sm text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2"
                onClick={() => onExit()}
              >
                Close
              </button>
            </div>
          </div>
        }
      />
    </>
  );
};
